var config={

  //为什么是8001的KOA的端口呢？因为前端程序不能读写后端电脑上的数据，必须通过KOA（8001口）或EXPRESS程序来转接
  //api:'http://a.itying.com/',//服务器API接口地址
	//api:'http://192.168.11.2:8001/',//服务器API接口地址，笔记本当前的IP，供同局域网的手机访问

  api:'http://www.haoyaya.top:8001/',//服务器API接口地址，阿里云的IP，供互联网手机访问
	api2:'http://www.haoyaya.top:8001',//云服务器模式
  return_url:'http://www.haoyaya.top:8080/',//云服务器模式，支付成功跳转地址，即VUE项目地址

  //api:'http://127.0.0.1:8001/',//本地调试，编译前，必须切换到云服务器模式
  //api2:'http://127.0.0.1:8001',//本地模式
  //return_url:'http://127.0.0.1:8080/',//本地调试，支付成功跳转地址，即VUE项目地址

  //前端和后端可以用同一个地址，原则上要分开，安全
}

export default config;



// WEBPACK FOOTER //
// ./src/model/config.js